<div class="spekwo-pricing">

    <!-- HERO -->
    <section class="pricing-hero">
        <div class="pricing-container">

            <h1>
                Flat, upfront
                <span>quote pricing</span>
            </h1>

            <p>
                One neutral number both sides trust, delivered in 72 hours or less,
                7 days a week. Pick the quote that fits where your deal is.
            </p>

        </div>
    </section>


    <!-- PRICING CARDS -->
    <section class="pricing-cards-section">
        <div class="pricing-container">

            <div class="pricing-grid">

                <!-- FULL SPEKWO -->
                <div class="pricing-card featured">

                    <div class="most-complete">
                        MOST COMPLETE
                    </div>

                    <div class="pricing-label">
                        FULL REPORT
                    </div>

                    <h2>
                        The Full speKwo
                    </h2>

                    <div class="price">
                        <span>$89</span>
                        <small>/ quote</small>
                    </div>

                    <p class="pricing-description">
                        Quote is refunded upon booking repairs. An estimate for
                        every single item on the home inspection identified as
                        "repair/replace." Best suited for clients who are not
                        sure of cost and need a little intel to assist in their
                        negotiations.
                    </p>

                    <div class="delivery-text">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a
                        routerLink="/spekwo-products"
                        [queryParams]="{ product: 'full' }"
                        class="pricing-btn primary"
                    >
                        Request the Full speKwo
                    </a>

                </div>


                <!-- ITEMIZED -->
                <div class="pricing-card">

                    <div class="pricing-label red">
                        CLIENT CHOICE
                    </div>

                    <h2>
                        Itemized Solution Estimate
                    </h2>

                    <div class="price">
                        <span>$59</span>
                        <small>/ quote</small>
                    </div>

                    <p class="pricing-description">
                        A quote for up to 40 items you choose from your recent
                        home inspection. Best suited for clients who know what
                        items are most important to them, or have already
                        finalized their DDRA.
                    </p>

                    <div class="delivery-text red">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a
                        routerLink="/spekwo-products"
                        [queryParams]="{ product: 'itemized' }"
                        class="pricing-btn secondary"
                    >
                        Request an Itemized Estimate
                    </a>

                </div>


                <!-- PRE-LIST -->
                <div class="pricing-card">

                    <div class="pricing-label red">
                        FOR SELLERS
                    </div>

                    <h2>
                        Pre-List Quote
                    </h2>

                    <div class="price">
                        <span>$59</span>
                        <small>/ quote</small>
                    </div>

                    <p class="pricing-description">
                        For clients preparing to go on the market and looking
                        to make the best first impression. Submit 1–2 pictures
                        per item with your own correlating description of what
                        you would like done.
                    </p>

                    <div class="delivery-text red">
                        ALL ITEMS QUOTED IN 24–72 HOURS
                    </div>

                    <a
                        routerLink="/spekwo-products"
                        [queryParams]="{ product: 'prelist' }"
                        class="pricing-btn secondary"
                    >
                        Request a Pre-List Quote
                    </a>

                </div>

            </div>


            <!-- PRICING NOTES -->
            <div class="pricing-notes">

                <div class="pricing-note">
                    <span>✓</span>
                    <p>
                        All repairs are completed in-house by speKwo's
                        full-time tradesmen. A $1,500 repair minimum applies
                        to completed work.
                    </p>
                </div>

                <div class="pricing-note">
                    <span>✓</span>
                    <p>
                        If speKwo completes work exceeding $1,500, the quote
                        cost is refunded.
                    </p>
                </div>

                <div class="pricing-note">
                    <span>✓</span>
                    <p>
                        We are so confident in the accuracy of our quote we
                        will complete the repairs for the price quoted.
                    </p>
                </div>

            </div>

        </div>
    </section>


    <!-- TRUSTED BY AGENTS -->
    <section class="reviews-section">

        <div class="pricing-container">

            <div class="section-label">
                <i></i>
                <span>TRUSTED BY AGENTS</span>
                <i></i>
            </div>

            <div class="section-heading">
                <h2>
                    What agents <span>say</span>
                </h2>
            </div>


            <div class="reviews-grid">

                <!-- REVIEW 1 -->
                <figure class="review-card">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        Spekwo has helped me buy back precious time in my
                        schedule, at an incredibly low cost. Every quote
                        received has saved me so many hours of time calling
                        and driving to meet contractors. The clients love
                        having a one stop shop for repairs & quotes. If you
                        are a full-time agent, this service is a must, to
                        keep you doing what you do best… selling houses!
                    </blockquote>

                    <figcaption>
                        <img
                            src="https://api.spekwo.com/bannerImages/2/2_Scott%20H.png"
                            alt="Scott H."
                        />

                        <span>
                            SCOTT H. · TRADE & TRYON REALTY
                        </span>
                    </figcaption>

                </figure>


                <!-- REVIEW 2 -->
                <figure class="review-card">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I always follow up with my clients after they have
                        work completed with your company and I am yet to have
                        any disappointed clients! Your process is easy and
                        convenient to use, which compliments a smooth process
                        for my clients throughout their purchasing process!
                    </blockquote>

                    <figcaption>
                        <img
                            src="https://api.spekwo.com/bannerImages/1/1_Judi%20S.png"
                            alt="Judi S."
                        />

                        <span>
                            JUDI S. · KELLER WILLIAMS BALLANTYNE
                        </span>
                    </figcaption>

                </figure>


                <!-- REVIEW 3 -->
                <figure class="review-card">

                    <div class="stars">
                        ★★★★★
                    </div>

                    <blockquote>
                        I first learned about spekwo when the buyers' agent
                        presented their quote to negotiate repairs. I was the
                        listing agent in that transaction. Because I constantly
                        deal with repairs and also renovations, I have a pretty
                        good idea of what fair and reasonable contractors
                        charge, and spekwo was exactly that. Since then, I have
                        been using them for my client's deals and highly
                        recommend them.
                    </blockquote>

                    <figcaption>
                        <img
                            src="https://api.spekwo.com/bannerImages/6/6_Claudia%20O.png"
                            alt="Claudia O."
                        />

                        <span>
                            CLAUDIA O. · COMPASS
                        </span>
                    </figcaption>

                </figure>

            </div>


            <div class="center-button">
                <a
                    routerLink="/testimonials"
                    class="read-reviews-btn"
                >
                    Read all reviews
                    <span>→</span>
                </a>
            </div>

        </div>

    </section>


    <!-- FAQ TEASER -->
    <section class="faq-section">

        <div class="pricing-container">

            <div class="section-label">
                <i></i>
                <span>02 / GOOD TO KNOW</span>
                <i></i>
            </div>

            <div class="faq-grid">

                <div class="faq-card">

                    <h3>
                        How can you quote without seeing the problem?
                    </h3>

                    <p>
                        Over 30 years in residential construction and 2,000+
                        reports reviewed and quoted in the last 8 years,
                        factoring labor, materials, and geography.
                    </p>

                </div>


                <div class="faq-card">

                    <h3>
                        Is my quote cost refundable?
                    </h3>

                    <p>
                        Yes. For any work completed by speKwo exceeding
                        $1,500, the whole amount of your speKwo cost is
                        refunded to the card used.
                    </p>

                </div>


                <div class="faq-card">

                    <h3>
                        What if I want the work done?
                    </h3>

                    <p>
                        speKwo deploys its own full-time tradesmen, the best
                        fit for your scope, and handles everything on the list.
                    </p>

                </div>

            </div>


            <div class="center-button">

                <a
                    routerLink="/faq"
                    class="faq-btn"
                >
                    Read all FAQs
                    <span>→</span>
                </a>

            </div>

        </div>

    </section>

</div>